import { UserContact } from '../iContact/user-contact';

export interface AccessHistoryDTO {
  courrierId: number;
  derniereVisite: string;
  droitActif: boolean;
  droitSources: string[];
  id: number;
  premiereVisite: string;
  userId: number;
}

export class AccessHistory {
  courrierId: number;
  derniereVisite: string;
  droitActif: boolean;
  droitSources: string[];
  id: number;
  premiereVisite: string;
  userId: number;
  name: string;

  constructor(data?: AccessHistoryDTO) {
    Object.assign(this, data);
  }

  setName(userContact: UserContact): void {
    this.name = `${userContact.contactForUser?.nom ?? ''} ${userContact.contactForUser?.prenom ?? ''}`;
  }
}
